/**
 * @file This file contains the configuration for the NPC aging lifecycle.
 * @module agingConfig
 */

/**
 * Defines the thresholds for NPC aging in game ticks (1 tick = 200ms).
 */
export const agingConfig = {
    AGE_TO_CHILD: 1000, // Ticks from Baby to Child (e.g., 200 seconds)
    AGE_TO_ADULT: 3000, // Ticks from Child to Adult (e.g., 600 seconds)
    AGE_TO_ELDER: 8000  // Ticks from Adult to Elder (e.g., 1600 seconds)
};